export const removeUnitOfMeasurement = (value) => {
	let results
	if (
		(results = /^(?:[-+]?(\d+(?:\.\d*)?|\.\d+)(?:em|ex|%|px|cm|mm|in|pt|pc|ch|rem|vh|vw|vmin|vmax)|0)$/i.exec(
			value
		)) !== null
	) {
		return parseFloat(results[1])
	} else {
		return 0
	}
}
